module.exports = __webpack_public_path__ + "img/the_weasleys_campsite.9fad10ab.jpg";